<template>
  <div class="box-father">
    <div class="box-header">
      <div class="box-header-left">
        <div class="box-header-left-text">消息中心   /</div>
        <div class="box-header-right">
          <div>消息管理</div>
        </div>
      </div>
    </div>
    <div class="section" v-if="st == 1">
      <div class="biaodan">
        <div class="biaodan-left">
          <div style="height: 100%">
            <el-form
              :inline="true"
              label-position="right"
              class="demo-form-inline"
              :model="form"
            >
              <el-form-item label="消息标题">
                <el-input
                  v-model="form.esTitle"
                  clearable
                  style="width: 150px"
                  size="mini"
                  placeholder="请输入消息标题"
                ></el-input>
              </el-form-item>
              <el-form-item label="发送内容">
                <el-input
                  v-model="form.esContent"
                  clearable
                  style="width: 150px"
                  size="mini"
                  placeholder="请输入发送内容"
                ></el-input>
              </el-form-item>
              <el-form-item label="接收人">
                <el-input
                  v-model="form.esReceiver"
                  clearable
                  style="width: 150px"
                  size="mini"
                  placeholder="请输入流程名称"
                ></el-input>
              </el-form-item>
              <el-form-item class="form-item">
                <el-button type="primary" @click="onSearch"   class="search"   size="mini">查询</el-button>
              </el-form-item>
            </el-form>
          </div>
        </div>
      </div>
      <div class="aside">
        <el-row>
          <el-col :span="24">
            <el-table
              class="disTable"
              ref="multipleTable"
              align="center"
              max-height="650"
              :header-cell-style="{
               background: '#F3F8FE',
                color: '#333333 ',
                textAlign: 'center',
              }"
              :cell-style="{ textAlign: 'center' }"
              :data="tableData"
            >
              <el-table-column
                align="center"
                prop="esTitle"
                label="消息标题"
                width="300"
                :show-overflow-tooltip="true"
              ></el-table-column>
              <el-table-column
                prop="esContent"
                label="发送内容"
                :show-overflow-tooltip="true"></el-table-column>
              <el-table-column
                prop="esReceiver"
                label="接收人"
                :show-overflow-tooltip="true"
              ></el-table-column>
              <el-table-column
                prop="esSendNum"
                label="发送次数"
                :show-overflow-tooltip="true"
              ></el-table-column>
              <el-table-column
                prop="esSendStatus"
                label="发送状态"
              >
                <template slot-scope="scope">
                  <div v-for="(item,index) in esSendStatusList" :key="index">
                    <div v-if="item.value == scope.row.esSendStatus">{{item.label}}</div>
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                prop="esType"
                label="发送方式"
              >
                <template slot-scope="scope">
                  <div v-for="(item,index) in templateTypeList" :key="index">
                    <div v-if="item.value == scope.row.esType">{{item.label}}</div>
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                prop="createTime"
                label="创建时间"
                :show-overflow-tooltip="true"
              ></el-table-column>
              <el-table-column
                label="操作"
                fixed="right"  width="300"
              >
                <template slot-scope="scope">
                  <el-popconfirm
                    title="确定删除吗？"
                    type="text"
                    trigger="click"
                    @confirm="deletetem(scope.row)"
                  >
                    <el-button type="text" slot="reference" style="margin-left: 10px;color:#ED6363 "
                    >删除</el-button
                    >
                  </el-popconfirm>
                </template>
              </el-table-column>
            </el-table>
          </el-col>
        </el-row>
        <div class="block">
          <el-pagination
            @current-change="handleCurrentChange"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"
            background
            :page-size="page.size"
            :page-sizes="[10, 50, 100, 200]"
            @size-change="handleSizeChange"
            :current-page.sync="currentPage"
            :style="{ textAlign: 'right', marginTop: '20px' }"
          ></el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { workflowTaskComplete} from "@/api/processManagement";
import {getSysMsgList} from "../../../api/systemManagement";
export default{
  data(){
    return{
      seeXML: '',
      timer: '',
      seqIdsList: [],
      tableDataTwo: [],
      dialogVisibleTwo: false,
      currentPageTwo: '1',
      dialogVisible: false,
      st: 1,
      totalTwo: '',
      ruleForm:{
        projectName: '',
        projectCode: '',
        status: 1,
        remark: '',
        id: '',
        managerId: '',
        managerName: ''
      },
      entryList: [],
      optionList:[],
      total: null,
      title: '查看流程图',
      titleTwo: '查看项目基本信息',
      currentPage: 1,
      form: {
        esReceiver: "",
        esTitle: "",
        esContent: '',
      },
      tableData: [],
      page: {
        page: 1,
        size: 10
      },
      formData: {
        itemLabel: '',
        status: '',
        dictType: '',
      },
      ruleFormTwo: {
        managerName: '',
        projectCode: '',
        projectName: '',
        createTime: '',
        status: 1,
        updateTime: '',
        remark: '',
      },
      UserArrayList: [],
      pageTwo: {
        page: 1,
        size: 10
      },
      templateTypeList: [
        {label: '系统', value:  1},
        {label: '短信', value: 2},
        {label: '邮件', value: 3},
      ],
      esSendStatusList: [
        {label: '未发送', value: 0},
        {label: '发送成功', value: 1},
        {label: '发送失败', value: 2},
        {label: '失败不再发送', value: -1},
      ],
      rules: {
        managerId: [
          { required: true, message: '请选择项目管理员', trigger: 'blur' },
        ],
        projectName: [
          { required: true, message: '请输入项目名称', trigger: 'blur' },
        ],
        projectCode: [
          { required: true, message: '请输入项目编码', trigger: 'blur' },
        ],
      },
    }
  },
  mounted() {
    this.queryDictionaries()
    this.st = 1
  },
  methods: {
    deletetem(val){
      if((this.total - 1) % this.page.size === 0) {
        if(this.page.page > 1) {
          this.page.page -= 1
        }
      }
      this.$axios.delete(`/sys/msg/delete/${val.id}`).then((res) =>{
        if (res.data.code == 200) {
          this.$message({
            message: '删除成功',
            type: 'success'
          });
          this.queryDictionaries()
        } else {
          this.$message({
            message: `${res.data.msg}`,
            type: 'warning'
          });
        }
      })
    },
    handleSizeChange(val) {
      this.page.size = val;
      this.queryDictionaries();
    },
    handleCurrentChange(val) {
      this.page.page = val;
      this.queryDictionaries();
    },
    // 查询字典类型列表
    onSearch(){
      this.page.page = 1;
      this.page.Size = 10;
      this.currentPage = 1;
      this.queryDictionaries()
    },
    // 查询项目列表
    async queryDictionaries(){
      let params = {
        esContent: this.form.esContent,
        esReceiver: this.form.esReceiver,
        esTitle: this.form.esTitle,
        page:this.page.page,
        size:this.page.size,
      }
      const res = await getSysMsgList(params);
      if (res.data.code == 200) {
        this.tableData = res.data.data.dataList ? res.data.data.dataList : [];
        this.total = res.data.data.total ? Number(res.data.data.total) : 0;
      }
    },
  },
}
</script>
<style scoped lang="less">
.box-father {
  height: 100%;
  width: 100%;
  padding: 0px 20px 20px 20px;
  background-color: #fff;
}
.box-header {
  width: 100%;
  height: 50px;
  display: flex;
  background-color: #fff;
  align-items: center;
  border-bottom: 1px solid #D8D8D8;
}
.box-header-left {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 100%;
}
.box-header-left-text {
  width: 120px;
  height: 14px;
  font-size: 14px;
  font-family: SourceHanSansCN-Regular, SourceHanSansCN;
  font-weight: 400;
  color: #B2B3C9;
  line-height: 21px;
  display: flex;
  align-items: center;
}
.box-header-right {
  font-weight: 400;
  color: #004AD1;
  line-height: 21px;
  width: 90%;
  height: 81%;
  margin-top: 3px;
  display: flex;
  align-items: center;
}
.section {
  height: 94.9%;
  background-color: #fff;
}
.el-menu-item.is-active {
  background: rgb(59, 121, 203, 0.2) !important;
}
.el-menu-item:hover {
  color: #1e90ff;
}
.daohang {
  display: flex;
  margin-left: 15px;
}
.daohang .el-menu-item {
  width: 100px;
  margin-left: 20px;
}
.biaodan {
  width: 100%;
  margin-top: 1px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 70px;
  .form-item{
    padding: 0;
    margin: 0;
  }
}
.biaodan-left {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.biaodan-left .el-form-item {
  margin-bottom: 0px;
}
.demo-form-inline {
  height: 100%;
  display: flex;
  //align-items: center;
  justify-content: space-between;
}
.export {
  width: 15%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 100%;
}
/* .aside{
  height: 100%;
}
.disTable{
  height: 100%;
} */
.element.style {
  height: 570px;
}
/* .el-tabs__header {
  padding: 0;
  position: relative;
  margin: 0 0 -28px !important;
} */
///deep/ .el-tabs__item {
//  height: 45px !important;
//  margin-top: 15px;
//}
.form-box {
  width: 100%;
  //display: flex;
  //flex-wrap: wrap;
  margin-top: 10px;
}
.form-content {
  width: 100%;
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}
.form-item {
  display: flex;
  justify-content: left;
}
.form-content-button {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
/deep/ ::-webkit-scrollbar-thumb {
  background-color: #dbdde3;
  border-radius: 5px;
}
.botton-box{
  width: 20%;
  height: 50px;
  display: flex;
  align-items: center;
}
.info input::-webkit-input-placeholder {
  /* placeholder颜色  */
  color: #606266;
}
//.el-form--inline .el-form-item__content {
//  width: 70%;
//}
.section .el-form-item__label {
  text-align: left;
}

.addValueDialog .el-form--inline .el-form-item {
  width: 100%;
}
.black{
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 20px;
}
/deep/ .el-dialog__wrapper .addValueDialog .el-form-item__label {
  width: 130px!important;
}
.aside .el-button {
  padding: 0;
}
</style>



// WEBPACK FOOTER //
// src/pages/messageCenter/messageManage/index.vue